import { combineReducers } from 'redux'
import SetAgeGroupDialogReducer from './dialogs/set-age-group/set-age-group.reducer'
import RemoveFromGroupDialogReducer from './dialogs/remove-from-group/remove-from-group.reducer'

const PupilsReducer = combineReducers({
  setAgeGroupDialog: SetAgeGroupDialogReducer,
  removeFromGroupDialog: RemoveFromGroupDialogReducer
})

export default PupilsReducer
